import { GenericCollectionFactory } from ".";
import { BUDGETS_GENERIC_IDS } from "../_constants/generics.constants";

export const BudgetCollection = GenericCollectionFactory(BUDGETS_GENERIC_IDS.BUDGETS, "uid");